<template>
  <v-dialog v-if="item.file" v-model="dialog" width="50%" max-width="700px" scrollable>
    <v-btn icon slot="activator"><slot></slot></v-btn>
    <v-card>
      <v-toolbar light>
        <v-btn icon @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Store Listing for {{item.name}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text style="height: 400px;">
        <v-container grid-list-lg>
          <v-layout row>
            <v-flex xs3 class="center-align">
              <img :src="item.file.thumbs.small" class="responsive-img elevation-5">
            </v-flex>
            <v-flex xs9>
              <v-form rel="storeitem">
                <v-switch label="Show In Store" v-model="storeItem.enabled"></v-switch>
                <v-text-field v-model="storeItem.title" label="Title"/>
                <v-text-field v-model="storeItem.subtitle" label="Subtitle / Client Item # / Document Name"/>
                <v-text-field v-model="storeItem.retail" label="Public Sell Price" prefix="$"/>
                <v-text-field v-model="storeItem.published_date" label="Published Date"/>
                <v-text-field v-model="storeItem.edition" label="Edition"/>
                <v-text-field v-model="storeItem.description" label="Description"/>
                <v-text-field v-model="storeItem.excerpt" label="Excerpt"/>
                <v-text-field v-model="storeItem.quotes" label="Quotes"/>
                <v-text-field v-model="storeItem.reviews" label="Reviews"/>
                <v-text-field v-model="storeItem.about" label="About"/>
                <v-text-field v-model="storeItem.contact" label="Contact"/>
                <v-text-field v-model="storeItem.website" label="Website"/>
                <v-text-field v-model="storeItem.returns" label="Returns"/>
                <v-text-field v-model="storeItem.isbn" label="ISBN"/>
                <v-text-field v-model="storeItem.ean_13" label="EAN-13"/>
                <v-text-field v-model="storeItem.upc" label="UPC"/>
                <v-text-field v-model="storeItem.client_item_number" label="Client Item #"/>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="sendToStore(item.id)">Update</v-btn>
        <v-btn flat @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api/gungho'
import Events from '@/api/events'

export default {
  props: {
    item: Object
  },

  data () {
    return {
      dialog: false,
      storeItem: {
        title: this.item.name,
        subtitle: '',
        retail: parseFloat(this.item.unit_prices[1]).toFixed(2),
        published_date: '',
        edition: '',
        description: '',
        excerpt: '',
        quotes: '',
        reviews: '',
        about: '',
        contact: '',
        website: '',
        returns: '',
        isbn: '',
        ean_13: '',
        upc: '',
        client_item_number: '',
        enabled: true
      }
    }
  },

  methods: {
    sendToStore (id) {
      api.newStoreItem(id, this.storeItem).then(data => {
        Events.$emit('toast', 'Item added to store')
        this.dialog = false
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// add-to-store.vue?004dab48